// 本地环境配置
module.exports = {
  title: ' voltshare-web-app',
  baseUrl: '', // 项目地址
  baseApi: '', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  //test
  // pk:'pk_test_51IsUDRACObXSZo7MKJbeGE1IABYBNK22k3MawZaMHPtUe1qCY3w8irzeBKNdyqQZ9UsaI22UH3gFg8xKwzYCmcDm00q6WdvFFh',

  //team 
  // pk: 'pk_test_51R7GvWGfldMqAwSjzFF06D16wDjuKhEum4KsOxf739o9tvfqP1VtVo4JeoTv9SPypShuhFVsQr5kY2pSp5bUTRmd00iWkjmfuD',

  //沙盒
  pk: 'pk_test_51SBWEKAM7ah7106AhI3u9HeHa7HIA9yet2HhwhWqxm39w1L3cGx8amhNX3My8tuoDMhDcXOaabY8lGYDaTaexqAf00cMS6VJ8l',
  successUrl: "https://127.0.0.1:8080/#/success",
  processUrl:"https://t-m.voltshare.co.uk/#/process",
  // processUrl:"https://proxy.uzhie.com.cn/#/process",
  APPID: '',
  APPSECRET: '',
  $cdn: '',
}
